import { H4, H5 } from '../../../AbstractElements';
import { Button, Form } from 'reactstrap';
import DataTable from 'react-data-table-component';
import FilterComponent from '../../FilterComponents/FilterComponent';
import { useThemeContext } from '../../../Context/ThemeContext';
import { useState } from 'react';
import SlipGajiColumns from '../constants/SlipGajiColumns';
import { useSlipGaji } from '../../../Context/SlipGajiContext';

const PreviewSlipGaji = ({ data, pending, setMode }) => {
  const slipGajiAPI = useSlipGaji();
  const [filterText, setFilterText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const { themeContext } = useThemeContext();

  const postItem = () => {
    setIsSubmitting(true);
    slipGajiAPI.postSlipGajiEmail(data).then(() => {
      setIsSubmitting(false);
    });
  };

  const filterStaff = (items) => {
    if (!filterText) {
      return items;
    }
  
    const searchCategories = ['nama'];
    const filteredItems = items?.filter((item) => {
      if (!item.nama) return true;
      return searchCategories.some((category) =>
        String(item[category]).toLowerCase().includes(filterText.toLowerCase()),
      );
    });
  
    return filteredItems;
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText('');
    }
  };

  const defaultMessage = `
Yth Bapak/Ibu {Redaksi},

    Sebagai informasi kami sampaikan Slip ${data?.keperluan} Bulan ${data?.data[0].periode}.
Bila ada pertanyaan silahkan email ke hennie.m@cs.ui.ac.id.

Regards,

SDM Fasilkom.




Ini adalah automatic generated email, harap tidak mereply email ini.`;

  const message = `
${data?.pesan}







Ini adalah automatic generated email, harap tidak mereply email ini.`;

  return (
    <Form>
      <div className="text-center">
        <H4>Email</H4>
      </div>
      <H5>
        {data?.judul === ''
          ? `[Kepegawaian] Slip ${data?.keperluan} ${data?.data[0].periode}`
          : `[Kepegawaian] ${data?.judul}`}
      </H5>
      <pre>{data?.pesan === '' ? defaultMessage : message}</pre>
      <div className="text-center">
        <H4>Attachment</H4>
      </div>
      <DataTable
        columns={SlipGajiColumns()}
        data={filterStaff(data?.data)}
        pagination
        selectableRowsHighlight
        highlightOnHover
        subHeader
        subHeaderComponent={
          <FilterComponent
            onFilter={(e) => {
              setFilterText(e.target.value);
            }}
            onClear={handleClear}
            filterText={filterText}
          />
        }
        subHeaderAlign="right"
        persistTableHead
        progressPending={pending}
        theme={themeContext}
      />
      <div className="d-flex justify-content-between mt-3">
        <Button
          color="primary"
          type="button"
          className="me-2"
          onClick={() => setMode('form')}
        >
          Kembali
        </Button>
        <Button
          color="primary"
          type="submit"
          className="me-2"
          disabled={isSubmitting}
          onClick={postItem}
        >
          {isSubmitting ? 'Mengirim...' : 'Kirim'}
        </Button>
      </div>
    </Form>
  );
};

export default PreviewSlipGaji;